import { trackInteraction } from 'client/javascript/analytics';
import { isMobile } from 'client/javascript/util/user_agent';
import { copyToClipboardWithoutDisplayingInput } from 'client/javascript/util/copy_to_clipboard';

const HIDDEN_CLASS = 'hidden';

// TODO: use reusable share button from src/client/javascript/share_button.js
// if you read this comment, please, refactor the code
// Jira ticket: https://jira.weworkers.io/browse/GROW-9778

export default class ShareButton {
  constructor() {
    this.shareButton = document.querySelector('#share-button');
    this.shareDropdown = document.querySelector('.share-dropdown');
    this.shareContainer = document.querySelector('.share-container');
    this.copyLinkButton = document.querySelector('#copy-link');
    this.showDropdown = false;

    this.checkIfOutsideTarget = this.checkIfOutsideTarget.bind(this);
    this.toggleShareDropdown = this.toggleShareDropdown.bind(this);
  }

  setUpShareButtonEvents() {
    this.setUpShareButton();
    this.setUpCopyLink();
    this.setUpShareOptionTracking();
  }

  setUpShareButton() {
    if (this.shareButton) {
      this.shareButton.addEventListener('click', this.toggleShareDropdown);
    }
  }

  toggleShareDropdown() {
    const fullUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;

    if (isMobile && navigator.share) {
      navigator.share({
        title: document.title,
        text: 'Check out this WeWork location:',
        url: fullUrl
      });
    } else {
      this.shareDropdown.classList.toggle(HIDDEN_CLASS);

      if (!this.showDropdown) {
        this.handleShowDropdown();
      } else {
        this.handleHideDropdown();
      }
    }

    trackInteraction({
      label: 'Click share dropdown'
    });
  }

  setUpCopyLink() {
    const buildingLink = this.copyLinkButton.dataset.link;

    this.copyLinkButton.addEventListener('click', () => {
      copyToClipboardWithoutDisplayingInput(this.copyLinkButton, buildingLink);
    });
  }

  setUpShareOptionTracking() {
    Array.from(this.shareDropdown.children).forEach(option => {
      option.addEventListener('click', () => {
        setTimeout(() => {
          this.shareDropdown.classList.add(HIDDEN_CLASS);
          this.handleHideDropdown();
        }, 300);

        trackInteraction({
          label: 'Click share',
          value: option.dataset.type
        });
      });
    });
  }

  handleShowDropdown() {
    document.addEventListener('click', this.checkIfOutsideTarget);
    this.showDropdown = true;
  }

  handleHideDropdown() {
    document.removeEventListener('click', this.checkIfOutsideTarget);
    this.showDropdown = false;
  }

  checkIfOutsideTarget(e) {
    if (this.shareContainer.contains(e.target)) {
      return;
    }

    this.shareDropdown.classList.add(HIDDEN_CLASS);
    this.handleHideDropdown();
  }
}
